/*
 * @Description: 公司设置
 * @Author: 杨志航
 * @Date: 2026-09-15 17:54:37
 */
import update from 'immutability-helper'
import React, { useCallback, useState, useEffect } from 'react'
import api from 'api'
import {
  Alert,
  message,
  Drawer,
  Switch,
} from 'antd'
import EditCompany from '../../module/EditCompany'
import DraggableTable from '@/components/DraggableTable'

const Main = props => {
  const { history } = props
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [editData, setEditData] = useState({})

  useEffect(() => {
    getList()
  }, [])

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getProfitReportCompanySort().then(data => {
      setList(data)
      setCount(data.length)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  const moveRow = useCallback((dragIndex, hoverIndex) => {
    const dragRow = list[dragIndex]
    const newData = update(list, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, dragRow],
      ],
    })
    setList(newData)
  }, [list])

  const handleSort = () => {
    const ids = list.map(item => item.cid)
    setLoading(true)
    api.updateProfitReportCompanySort({ 
      id: ids 
    }).then(() => {
      message.success('排序成功')
      getList()
    }).catch(() => getList())
  }

  const onEdit = record => {
    setEditData(record)
    setEditVisible(true)
  }

  const changeShow = (value, id) => {
    setLoading(true)
    api.updateProfitReportCompanyShow({
      id,
      isShow: value ? 1 : 2,
    }).then(() => {
      message.success('修改成功')
      getList()
    }).catch(() => setLoading(false))
  }

  const columns = [
    {
      title: '排序',
      dataIndex: 'sort',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'OA公司简称',
      dataIndex: 'companyName',
    },
    {
      title: 'OA公司全称',
      dataIndex: 'companyFullName',
    },
    {
      title: '公司类型',
      dataIndex: 'companyType',
    },
    {
      title: '小程序公司名称',
      dataIndex: 'name',
    },
    {
      title: '小程序公司负责人',
      dataIndex: 'leaderName',
    },
    {
      title: '下级事业群数量',
      dataIndex: 'groupNum',
    },
    {
      title: '在职主账号人数',
      dataIndex: 'personNum',
    },
    {
      title: '是否显示',
      dataIndex: 'isShow',
      render: (text, record) => (
        <Switch checked={text === 1} onChange={value => changeShow(value, record.cid)} />
      ),
    },
    {
      title: '操作',
      key: 'set',
      fixed: 'right',
      align: 'center',
      width: 180,
      render: (text, record) => (
        <>
          <a onClick={() => onEdit(record)}>公司设置</a>
          <a onClick={() => history.push(`/ach/profit/companysetting/groupsetting?id=${record.cid}`)} style={{ marginLeft: 8 }}>事业群详情</a>
        </>
      ),
    },
  ]

  return (
    <>
      <Alert className="corp-count" message={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>总共{count}条数据</span>
          <span style={{ marginLeft: 20, color: '#168FFF', cursor: 'pointer' }} onClick={handleSort}>保存排序</span>
        </div>
      } type="info" showIcon />
      <DraggableTable
        rowKey={(_, index) => index}
        size="small"
        dataSource={list}
        columns={columns}
        pagination={false}
        loading={loading}
        moveRow={moveRow}
      />
      <Drawer
        title="公司设置"
        width={600}
        onClose={() => setEditVisible(false)}
        visible={editVisible}
        destroyOnClose={true}
      >
        <EditCompany editData={editData} setVisible={setEditVisible} getList={getList} />
      </Drawer>
    </>
  )
}
export default Main